<template>
  <div id="app">
    <v-app>
      <!-- Pantalla de login: se muestra cuando NO hay sesión activa -->
      <login v-if="!logeado" @logeado="onLog" />

      <!-- Cambio de contraseña inicial obligatorio -->
      <cambiar-password
        v-if="logeado && debeCambiarPassword"
        @cambiado="onPasswordCambiada"
      />

      <!-- Aplicación principal: solo cuando está autenticado y no debe cambiar pass -->
      <div v-if="logeado && !debeCambiarPassword">
        <encabezado @toggleDark="toggleDark" />
        <v-main>
          <v-container fluid class="pa-3 pa-md-4">
            <router-view />
            <pie-component />
          </v-container>
        </v-main>
      </div>

      <!-- Snackbar global de notificaciones -->
      <v-snackbar
        v-model="mostrarMensaje"
        :timeout="3500"
        :color="mensaje.color"
        top
      >
        <v-icon left small>{{ mensaje.icono }}</v-icon>
        {{ mensaje.texto }}
        <template v-slot:action="{ attrs }">
          <v-btn text v-bind="attrs" @click="mostrarMensaje = false">Cerrar</v-btn>
        </template>
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import Encabezado from './components/Encabezado.vue'
import Login from './components/Usuarios/Login.vue'
import CambiarPassword from './components/Usuarios/CambiarPassword.vue'
import PieComponent from './components/Dialogos/PieComponent.vue'
import HttpService from './Servicios/HttpService'
import { aplicarTema, cargarTemaGuardado, toggleModoOscuro } from './plugins/tema'

export default {
  name: 'App',
  components: { Encabezado, Login, CambiarPassword, PieComponent },

  data: function() {
    return {
      logeado: false,
      debeCambiarPassword: false,
      mostrarMensaje: false,
      mensaje: { texto: '', color: 'success', icono: 'mdi-check-circle' },
    }
  },

  mounted: function() {
    // 1. Aplicar tema guardado en localStorage (carga instantánea de colores)
    cargarTemaGuardado(this.$vuetify)

    // 2. Verificar si hay sesión JWT activa
    var token = localStorage.getItem('jwt_token')
    if (token) {
      this.logeado = true
    }

    // 3. Cargar ajustes del gimnasio (es una llamada pública — no requiere JWT)
    this.cargarAjustes()
  },

  methods: {
    onLog: function(respuesta) {
      if (!respuesta || !respuesta.resultado) {
        this.mostrar(
          (respuesta && respuesta.error) || 'Credenciales incorrectas',
          'error',
          'mdi-alert-circle'
        )
        return
      }

      // Guardar JWT y datos de sesión
      if (respuesta.token) {
        localStorage.setItem('jwt_token', respuesta.token)
      }
      if (respuesta.datos) {
        localStorage.setItem('nombreUsuario', respuesta.datos.nombreUsuario || '')
        localStorage.setItem('idUsuario', respuesta.datos.idUsuario || '')
      }
      localStorage.setItem('rolUsuario', respuesta.rol || 'recepcionista')

      this.logeado = true

      // Primer login: pedir cambio de contraseña
      if (respuesta.resultado === 'cambia') {
        this.debeCambiarPassword = true
        this.mostrar('Por favor cambia tu contraseña para continuar', 'warning', 'mdi-lock-alert')
        return
      }

      var nombre = (respuesta.datos && respuesta.datos.nombreUsuario) || 'usuario'
      this.mostrar('Bienvenido, ' + nombre + '!', 'success', 'mdi-check-circle')
      this.$router.push({ name: 'InicioComponent' }).catch(function() {})
    },

    onPasswordCambiada: function() {
      this.debeCambiarPassword = false
      this.mostrar('Contraseña actualizada. Bienvenido!', 'success', 'mdi-check-circle')
      this.$router.push({ name: 'InicioComponent' }).catch(function() {})
    },

    cargarAjustes: function() {
      var self = this
      // Este endpoint es PÚBLICO — no requiere JWT.
      // Si falla, simplemente se usan los valores por defecto.
      HttpService.obtenerConDatos({ metodo: 'obtener' }, 'ajustes.php')
        .then(function(resultado) {
          if (!resultado) return
          localStorage.setItem('nombreGimnasio',   resultado.nombre    || '')
          localStorage.setItem('logoGimnasio',      resultado.logo      || '')
          localStorage.setItem('telefonoGimnasio',  resultado.telefono  || '')
          localStorage.setItem('direccionGimnasio', resultado.direccion || '')
          localStorage.setItem('correoGimnasio',    resultado.correo    || '')
          localStorage.setItem('monedaGimnasio',    resultado.moneda    || '$')
          localStorage.setItem('ajustes', JSON.stringify(resultado))
          aplicarTema(self.$vuetify, resultado)
        })
        .catch(function() {
          // Silencioso — usar valores por defecto del tema
        })
    },

    toggleDark: function() {
      toggleModoOscuro(this.$vuetify)
    },

    mostrar: function(texto, color, icono) {
      this.mensaje = {
        texto: texto,
        color: color || 'success',
        icono: icono || 'mdi-information',
      }
      this.mostrarMensaje = true
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/App.vue